export default __webpack_public_path__ + "static/CLUB-Q-e7e1b3f41b69ac55191e755ecceca720.png";